// components/AdminBanner.js
import logger from 'utils/logger';
import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const AdminBanner = () => {
  const { currentUser } = useAuth();
  const [bannerData, setBannerData] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!currentUser) {
      return;
    } // Only proceed if user is logged in

    const fetchBannerData = async () => {
      try {
        const docRef = doc(db, 'adminSettings', 'siteBanner');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setBannerData(data);

          // Check if banner is enabled and not dismissed in localStorage
          if (data.enabled && !localStorage.getItem(`bannerDismissed_${currentUser.uid}`)) {
            setShowBanner(true);
          }
        }
      } catch (error) {
        logger.error('Error fetching banner data:', error);
      }
    };

    fetchBannerData();
  }, [currentUser]); // Add currentUser as dependency

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem(`bannerDismissed_${currentUser.uid}`, 'true');
  };

  if (!currentUser || !showBanner || !bannerData) {
    return null;
  }

  return (
    <Alert
      variant={bannerData.variant || 'info'}
      className="mb-0 rounded-0 text-center"
      style={{
        backgroundColor: bannerData.backgroundColor || '',
        color: bannerData.textColor || '',
        border: 'none'
      }}
    >
      {bannerData.imageUrl && (
        <img
          src={bannerData.imageUrl}
          alt="Banner"
          style={{ maxWidth: '100%', marginBottom: '10px' }}
          referrerPolicy="no-referrer"
        />
      )}
      <div className="d-flex justify-content-between align-items-center">
        <div dangerouslySetInnerHTML={{ __html: bannerData.message }} />
        <Button
          variant="link"
          onClick={handleDismiss}
          style={{ color: bannerData.textColor || 'inherit' }}
        >
          ×
        </Button>
      </div>
    </Alert>
  );
};

export default AdminBanner;
